import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';

import { DollarSign, Save, RefreshCw, ShoppingCart, MapPin, Building2, Tag, BarChart3, Settings, Recycle } from 'lucide-react';

import BackButton from '../../components/BackButton';
import RemisesCommunityplaceTab from '../RemisesCommunityplaceTab';

import TarifsTab from '../gestion-tarifs/TarifsTab';
import TerritoiresTab from '../gestion-tarifs/TerritoiresTab';
import TypesTab from '../gestion-tarifs/TypesTab';
import EntreprisesTab from '../gestion-tarifs/EntreprisesTab';
import DemandesTab from '../gestion-tarifs/DemandesTab';
import TarifDialog from '../gestion-tarifs/TarifDialog';
import StatsDialog from '../gestion-tarifs/StatsDialog';
import DemandeDialog from '../gestion-tarifs/DemandeDialog';
import ViewDemandeDialog from '../gestion-tarifs/ViewDemandeDialog';
import { useGestionTarifs } from './useGestionTarifs';

const GestionTarifsDemandesPubliques = () => {
  const ctx = useGestionTarifs();
  const { activeTab, _tarifs, demandes, stats, remisesPolitique, remisesPolitiqueLoading, setActiveTab, setStatsDialogOpen, setRemisesPolitique, fetchAllData, saveRemisesPolitique } = ctx;
  return (
    <div className="p-6 space-y-6 bg-gradient-to-br from-slate-50 via-emerald-50/30 to-teal-50/30 min-h-screen">
      {/* Bouton retour */}
      <BackButton label="Retour" className="mb-2" />
      
      {/* Header Professionnel */}
      <div className="bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 rounded-2xl p-6 text-white shadow-xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
              <ShoppingCart className="h-8 w-8" />
            </div>
            <div>
              <h1 className="text-2xl font-bold">Gestion des Tarifs - Demandes Publiques</h1>
              <p className="text-white/80 text-sm">Configurez les coûts d'achat des leads par territoire, type et entreprise</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="flex gap-2">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 text-center">
                <div className="text-2xl font-bold">{stats.total_demandes || demandes.length}</div>
                <div className="text-xs text-white/70">Demandes</div>
              </div>
              <div className="bg-green-500/30 backdrop-blur-sm rounded-lg px-4 py-2 text-center">
                <div className="text-2xl font-bold">{stats.demandes_achetees || 0}</div>
                <div className="text-xs text-white/70">Achetées</div>
              </div>
              <div className="bg-yellow-500/30 backdrop-blur-sm rounded-lg px-4 py-2 text-center">
                <div className="text-2xl font-bold">{(stats.revenus_total || 0).toLocaleString('fr-FR')}€</div>
                <div className="text-xs text-white/70">Revenus</div>
              </div>
            </div>
            
            <Button onClick={() => setStatsDialogOpen(true)} variant="ghost" className="text-white hover:bg-white/20">
              <BarChart3 className="h-5 w-5" />
            </Button>
            <Button onClick={fetchAllData} variant="ghost" className="text-white hover:bg-white/20">
              <RefreshCw className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-6 bg-white shadow-md rounded-xl p-1">
          <TabsTrigger value="tarifs" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Tarifs Généraux
          </TabsTrigger>
          <TabsTrigger value="territoires" className="flex items-center gap-2">
            <MapPin className="h-4 w-4" />
            Par Territoire
          </TabsTrigger>
          <TabsTrigger value="types" className="flex items-center gap-2">
            <Tag className="h-4 w-4" />
            Par Type
          </TabsTrigger>
          <TabsTrigger value="entreprises" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            Par Entreprise
          </TabsTrigger>
          <TabsTrigger value="demandes" className="flex items-center gap-2">
            <ShoppingCart className="h-4 w-4" />
            Demandes
          </TabsTrigger>
          <TabsTrigger value="remises" className="flex items-center gap-2" data-testid="tab-remises-communityplace">
            <Recycle className="h-4 w-4" />
            Remises
          </TabsTrigger>
        </TabsList>

        {/* Tab Tarifs Généraux */}
        <TarifsTab ctx={ctx} />

        {/* Tab Par Territoire */}
        <TerritoiresTab ctx={ctx} />

        {/* Tab Par Type — Multi-Espaces Premium */}
        <TypesTab ctx={ctx} />

        {/* Tab Par Entreprise */}
        <EntreprisesTab ctx={ctx} />

        {/* Tab Demandes */}
        <DemandesTab ctx={ctx} />

        {/* ============================================
            Tab REMISES COMMUNITYPLACE — politique + audit des remises COOPER
            ============================================ */}
        <TabsContent value="remises" className="mt-4 space-y-4">
          {/* V36.41 — Editeur de Politique de Remises (Super Admin) */}
          <Card className="border-0 shadow-lg border-l-4 border-l-orange-500" data-testid="remises-politique-editor">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Settings className="h-5 w-5 text-orange-600" />
                Politique de Remises (configurable)
              </CardTitle>
              <CardDescription>
                Modifiez les parametres de la politique de remise Communityplace.
                Ces valeurs s'appliquent en temps reel a tous les COOPER'S.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-4 rounded-lg bg-orange-50 border border-orange-200">
                  <Label className="text-xs font-bold uppercase tracking-wider text-orange-700">Delai de grace</Label>
                  <div className="flex items-center gap-2 mt-2">
                    <Input
                      type="number"
                      min="0"
                      value={remisesPolitique.delai_grace_jours}
                      onChange={(e) => setRemisesPolitique({ ...remisesPolitique, delai_grace_jours: parseInt(e.target.value) || 0 })}
                      className="text-2xl font-bold text-orange-900 border-orange-300"
                      data-testid="remises-delai-grace"
                    />
                    <span className="text-sm font-medium text-orange-700">jours</span>
                  </div>
                  <p className="text-[11px] text-slate-500 mt-1">Sans penalite apres l'achat</p>
                </div>
                <div className="p-4 rounded-lg bg-rose-50 border border-rose-200">
                  <Label className="text-xs font-bold uppercase tracking-wider text-rose-700">Penalite de retard</Label>
                  <div className="flex items-center gap-2 mt-2">
                    <Input
                      type="number"
                      min="0"
                      value={remisesPolitique.penalite_credits_par_jour}
                      onChange={(e) => setRemisesPolitique({ ...remisesPolitique, penalite_credits_par_jour: parseInt(e.target.value) || 0 })}
                      className="text-2xl font-bold text-rose-900 border-rose-300"
                      data-testid="remises-penalite-jour"
                    />
                    <span className="text-sm font-medium text-rose-700">credits/j</span>
                  </div>
                  <p className="text-[11px] text-slate-500 mt-1">Au-dela du delai de grace</p>
                </div>
                <div className="p-4 rounded-lg bg-amber-50 border border-amber-200">
                  <Label className="text-xs font-bold uppercase tracking-wider text-amber-700">Quota anti-abus</Label>
                  <div className="flex items-center gap-2 mt-2">
                    <Input
                      type="number"
                      min="1"
                      value={remisesPolitique.max_remises_par_cooper_30j}
                      onChange={(e) => setRemisesPolitique({ ...remisesPolitique, max_remises_par_cooper_30j: parseInt(e.target.value) || 1 })}
                      className="text-2xl font-bold text-amber-900 border-amber-300"
                      data-testid="remises-max-30j"
                    />
                    <span className="text-sm font-medium text-amber-700">max / 30j</span>
                  </div>
                  <p className="text-[11px] text-slate-500 mt-1">Par COOPER sur 30j glissants</p>
                </div>
              </div>
              <div className="mt-4 space-y-2">
                <Label className="text-xs font-semibold text-slate-700">Description / Note d'information COOPER</Label>
                <Textarea
                  rows={2}
                  value={remisesPolitique.description || ''}
                  onChange={(e) => setRemisesPolitique({ ...remisesPolitique, description: e.target.value })}
                  placeholder="Texte affiche aux COOPER'S..."
                  data-testid="remises-description"
                />
              </div>
              <div className="flex justify-end mt-4">
                <Button onClick={saveRemisesPolitique} className="bg-orange-600 hover:bg-orange-700" data-testid="save-remises-politique" disabled={remisesPolitiqueLoading}>
                  <Save className="h-4 w-4 mr-2" />
                  Sauvegarder la politique
                </Button>
              </div>
            </CardContent>
          </Card>

          <RemisesCommunityplaceTab />
        </TabsContent>
      </Tabs>

      {/* Dialog Tarif */}
      <TarifDialog ctx={ctx} />

      {/* Dialog Stats */}
      <StatsDialog ctx={ctx} />

      {/* V36.41 — Dialog Admin Demande Publique (CRUD) */}
      <DemandeDialog ctx={ctx} />

      {/* V36.41b — Dialog Visualisation Ultra-Pro */}
      <ViewDemandeDialog ctx={ctx} />
    </div>
  );
};

export default GestionTarifsDemandesPubliques;
